import { makeStyles } from "@material-ui/core";

export const QuickbooksAccountsStyle = makeStyles((theme) => ({
    fields: {
        padding: '1em'
    },
    alert: {
        margin: '1em'
    }
}));